import { render } from "./select-interval-component.vue?vue&type=template&id=3a960738"
import script from "./select-interval-component.vue?vue&type=script&lang=ts"
export * from "./select-interval-component.vue?vue&type=script&lang=ts"

import "./select-interval-component.vue?vue&type=style&index=0&id=3a960738&lang=less"
script.render = render

export default script